import {Form} from 'antd'
import http from '@/biz/http.mjs'
import {refreshPerm} from '@/biz/user.mjs'
import {useChooseBaseline} from '@/biz/baseline/index.mjs'
import {AbortError} from '@/script/Error.mjs'
import runAsync from '@/script/runAsync.mjs'
import {InputText} from '@/components/Form/index.mjs'
import {Prompt, useOpenModal} from '@/components/Modal/index.mjs'
import {createPlugin} from '@/components/MindMap/index.mjs'

export default () => {
    const chooseBaseline = useChooseBaseline()
    const openModal = useOpenModal()

    const extensions = map => {
        if ('_ISRF_MAP' !== map.data.mapTypeCode) {
            return {}
        }

        return {
            async addBranch() {
                const {pkid, prjId, prjPatternId, sVer} = map.root.data
                const baseline = await chooseBaseline({prjPatternId})

                if (! baseline) {
                    return
                }

                const {pkid: baselineId} = baseline

                await runAsync(
                    () => http.post(
                        '/prjbaselines/addIncrementDpForIsrf',
                        {baselineId, pkid, prjId, sVer}
                    ),

                    {action: '添加增量分支'}
                )

                await runAsync(
                    () => map.refreshMap(),
                    {action: '刷新地图'}
                )
            },

            async createBranch() {
                const {pkid, prjId} = map.root.data

                const userInputs = await openModal(
                    <Prompt title="创建增量分支">
                        <Form.Item
                            label="分支名称"
                            name="pblName"
                        >
                            <InputText />
                        </Form.Item>
                    </Prompt>
                )

                if (! userInputs) {
                    throw new AbortError
                }

                const {pblName} = userInputs

                await runAsync(
                    () => http.post(
                        '/prjbaselines/createBranchForIsrf',
                        {pblName, pkid, prjId}
                    ),

                    {action: '创建增量分支'}
                )

                await runAsync(
                    () => map.refreshMap(),
                    {action: '刷新地图'}
                )

                await runAsync(refreshPerm, {action: '刷新权限'})
            },

            async removeBranch() {
                const {pkid, prjId, sVer} = map.root.data

                await runAsync(
                    () => http.post(
                        '/isrf/removeIncbranchIsrfRel',
                        {pkid, prjId, sVer}
                    ),

                    {action: '移除增量分支'}
                )

                await runAsync(
                    () => map.refreshMap(),
                    {action: '刷新地图'}
                )
            },
        }
    }

    return createPlugin('isrf', {extensions})
}
